<template>
  <b-modal title="Despesas" v-model="show" size="xl">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE DESPESAS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getDespesas" :fields="fields.despesa">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(valor)="data">
          <div>
            <p>{{ formatter.format(data.item.valor) }}</p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="deletar(data.item)" v-b-tooltip.hover title="Deletar">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAIS DE USO :::::::::::::::::::::::::::: -->
    <despesa-edit-modal ref="despesaEdit" @update="update()" />
    <confirm-modal ref="confirmDelDespesa" :descricao="'Deseja realmente remover a despesa ?'" @executar="executar()" />

    <template #modal-footer>
      <b-button class="pl-2 pr-3" variant="info" @click="adicionar()">
        <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
      </b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { VMoney } from "v-money";
import { useEquipeStore } from "@/stores/EquipeStore";
import TableFields from "@/tools/TableFields";
import Equipe from "@/models/Equipe";
import Despesa from "@/models/Despesa";
import DespesaModal from "@/components/modals/equipe/DespesaModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";

export default {
  name: "DespesaListModal",

  components: {
    "despesa-edit-modal": DespesaModal,
    "confirm-modal": ConfirmModal,
  },

  directives: { money: VMoney },

  data() {
    return {
      show: false,
      fields: new TableFields(),
      equipe: new Equipe(0, "", "Nova Equipe", new Date(), 0.0),
      despesa: new Despesa(0, "Nova Despesa", new Date(), 0.0, ""),
      despesas: [],
      formatter: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }),
    };
  },

  methods: {
    editar(despesa) {
      despesa.equipe = this.equipe;
      this.$refs.despesaEdit.call(despesa);
    },

    adicionar() {
      let despesa = new Despesa(0, "Nova Despesa", new Date(), 0.0, "");
      despesa.equipe = this.equipe;
      this.$refs.despesaEdit.call(despesa);
    },

    deletar(despesa) {
      this.despesa.update(despesa);
      this.$refs.confirmDelDespesa.call();
    },

    executar() {
      this.equipeStore.REMOVER_DESPESA(this.despesa.id).then(() => {
        this.update();
      });
    },

    update() {
      this.equipeStore.LISTAR_DESPESAS(this.equipe.id).then(() => {
        this.despesa = new Despesa(0, "Nova Despesa", new Date(), 0.0, "");
        this.despesas = this.getDespesas;
      });
    },

    call(equipe) {
      this.show = !this.show;
      this.equipe = equipe;
      this.update();
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipeStore = useEquipeStore();
    const { getDespesas } = storeToRefs(equipeStore);

    return {
      store,
      equipeStore,
      getDespesas,
    };
  },
};
</script>

<style lang="scss" scoped></style>
